<template>
        <div id="home">
          <!-- 头部 -->
          <Header title="contact"></Header>
          <Banner :bgImg="bannerImg" height="900" :title="'contact'" :prjPosit="'leftP'"></Banner>
            <!-- 尾部 -->
          <Footer></Footer>
        </div>
      </template>
      
      <script>
        import Header from "../../components/header.vue";
        import Banner from "../../components/banner.vue";
    
        import Footer from "../../components/footer.vue";
        import bannerImg from  "@/assets/images/bg6.png"
        export default {
          name: "home",
          components: {
            Header,
            Banner,
            Footer,
          },
          data(){
            return{
              bannerImg:bannerImg,
           
            }
          }
        };
      </script>
      <style lang="scss" scoped>
        /* @import url("../assets/css/common.scss"); */
        @import url("https://fonts.googleapis.com/css?family=Work+Sans:400,700,900");
        $anim-text-offset: 1em;
      </style>